module.exports = __webpack_public_path__ + "img/set-app.d72326ad.png";